import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { TypeRampV2 } from "../../typography";
import { FormLabelValidationState } from "../types";
import { formLabelColorTheme } from "./formLabelColorTheme";

interface FormLabelValidationProps {
    themeMode: RequiredThemeKeys;
    validationState: FormLabelValidationState;
}

export const FormLabelValidation = styled(TypeRampV2)<FormLabelValidationProps>`
    font-weight: 400;
    margin-top: 1px;
    color: ${({ themeMode, validationState }) => formLabelColorTheme.color[validationState](themeMode)};
`;
